import './Row.css'

const Row = ({ children }) => (
  <div className='Row'>
    {children}
  </div>
)
export default Row
